<div class="modal-container">
  <div class="modal-heading p-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6><i class="ai-text-gradient fa fa-stars mr-1"></i>Let our <span class="ai-text-gradient">Gen AI</span> do the job</h6>
      <span class="f-14 pointer" (click)="closeModal()"><i class="fa fa-times"></i></span>
    </div>
    <p class="m-0 f-12">Simply answer a couple of questions and let our AI do the rest</p>
  </div>
  <div class="modal-body">
    <form [formGroup]="aiPromptFormGroup" (ngSubmit)="submitModal($event)">
      <div class="mb-3">
        <div class="mb-1">What would you like our Gen AI to do for you?<span class="text-danger">*</span></div>
          <input data-testid="auto-app-email-campaign-assistant-input-1" #promptDropDownTrigger="matAutocompleteTrigger" [matAutocompleteConnectedTo]="promptDropDownOrigin" formControlName="prompt_id" type="text" class="form-control form-control-sm" placeholder="E.g. Write a blog post, create a social media post, etc." name="task" [matAutocomplete]="promptDropDown" required hidden>
          <div (click)="togglePrompt($event)" matAutocompleteOrigin #promptDropDownOrigin="matAutocompleteOrigin">
            <div class="d-flex align-items-center justify-content-between border p-2 rounded pointer">
              <div class="d-flex align-items-center" style="gap: 10px;">
                <div class="f-14 p-2 rounded-circle bg-color-company" *ngIf="currentPrompt">
                  <i class="fa" [ngClass]="currentPrompt.icon"></i>
                </div>
                <div class="f-14" *ngIf="currentPrompt">
                  <div class="m-0 font-weight-500">{{currentPrompt.title}}</div>
                  <div class="f-12">{{currentPrompt.description}}</div>
                </div>
                <div class="f-14" *ngIf="!currentPrompt">Select a prompt</div>
              </div>
              <div class="f-14 pointer"><i class="fa fa-chevron-down"></i></div>
            </div>
          </div>
        <mat-autocomplete class="prompt-css" (optionSelected)="promptSelected($event)" #promptDropDown="matAutocomplete">
          <mat-option *ngFor="let prompt of prompts" [value]="prompt.value">
            <div class="d-flex align-items-center justify-content-between p-2">
              <div class="d-flex align-items-center" style="gap: 10px;">
                <div class="f-14 p-2 rounded-circle bg-color-company">
                  <i class="fa" [ngClass]="prompt.icon"></i>
                </div>
                <div class="f-14">
                  <div class="m-0 font-weight-500">{{prompt.title}}</div>
                  <div class="f-12">{{prompt.description}}</div>
                </div>
              </div>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="mb-3">
        <div class="mb-1">Select<span class="text-danger">*</span></div>
        <div class="d-flex align-items-center justify-content-start" style="gap: 10px;">
          <div>
            <label class="position-relative d-flex align-items-center p-2 rounded-lg pointer mb-0" style="gap: 10px;" for="aiJD">
              <input data-testid="auto-app-email-campaign-assistant-input-2" formControlName="promptType" type="radio" name="promptType" id="aiJD" value="JD" required>
              <div class="f-14"><i class="fa-regular fa-memo-pad mr-1"></i>Job Description</div>
              <div class="border position-absolute h-100 w-100 rounded-lg" style="left: 0;"></div>
            </label>
          </div>
          <div>
            <label class="position-relative d-flex align-items-center p-2 rounded-lg pointer mb-0" style="gap: 10px;" for="aiRole">
              <input data-testid="auto-app-email-campaign-assistant-input-3" formControlName="promptType" type="radio" name="promptType" id="aiRole" value="Role" required>
              <div class="f-14"><i class="fa-regular fa-id-card-clip mr-1"></i>Role Title</div>
              <div class="border position-absolute h-100 w-100 rounded-lg" style="left: 0;"></div>
            </label>
          </div>
        </div>
      </div>
      <ng-container *ngIf="aiPromptFormGroup.get('promptType').value === 'Role'">
        <div class="mb-3">
          <div class="mb-1">What role are you hiring for?<span class="text-danger">*</span></div>
          <input data-testid="auto-app-email-campaign-assistant-input-4" formControlName="role" type="text" class="form-control form-control-sm" placeholder="E.g. Marketing Manager, Sales Executive, etc." name="role" required>
          <div *ngIf="(aiPromptFormGroup.get('role').touched || aiPromptFormGroup.get('role').dirty) && aiPromptFormGroup.get('role').hasError('required')" class="f-12 text-danger">Please provide a role</div>
        </div>
      </ng-container>
      <ng-container *ngIf="aiPromptFormGroup.get('promptType').value === 'JD'">
        <div class="mb-3">
          <div class="mb-1 d-flex justify-content-between align-items-center"><span>Job Description<span class="text-danger">*</span></span><span class="text-webbtree-green f-12 pointer" *ngIf="false" (click)="toggleJDOption()"><ng-container *ngIf="promptJDMode === 'write'">Upload</ng-container><ng-container *ngIf="promptJDMode === 'upload'">Write</ng-container> instaed?</span></div>
          <div class="position-relative drop-zone">
            <textarea data-testid="auto-app-email-campaign-assistant-textarea-1" formControlName="jd" type="text" class="form-control form-control-sm" placeholder="Paste description here" name="jd" rows="5" required></textarea>
            <div *ngIf="promptJDMode === 'upload'" (drop)="jdUploadDrop($event)" (dragover)="jdUploadDragOver($event)">
              <div (click)="openUploadDialog()" class="d-flex align-items-center justify-content-center h-100 w-100 position-absolute" [ngClass]="!jdFileMeta ? 'pointer' : ''" style="top: 0; left: 0;background: white; border: 2px rgba(0, 0, 0, 0.05) dashed;">
                <div class="d-flex align-items-center justify-content-center h-100 w-100">
                  <ng-container *ngIf="jdFileMeta">
                    <div class="d-flex align-items-center justify-content-center h-100 w-100">
                      <div class="d-flex align-items-center justify-content-center" style="gap: 10px;">
                        <div class="f-14"><i class="fa fa-file-alt"></i></div>
                        <div class="f-14 text-truncate" [title]="jdFileMeta" style="max-width: 300px">{{ jdFileMeta }}</div>
                        <div class="f-14 pointer" (click)="removeJDFile($event)"><i class="fa fa-times"></i></div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!jdFileMeta">
                    <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100">
                      <div class="f-14 text-center">Drop your file here or click to upload</div>
                      <div class="f-14 text-center">Supported file types: .doc, .docx, .pdf, .txt</div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="(aiPromptFormGroup.get('jd').touched || aiPromptFormGroup.get('jd').dirty) && aiPromptFormGroup.get('jd').hasError('required')" class="f-12 text-danger">Please <ng-container *ngIf="promptJDMode === 'write'">provide</ng-container><ng-container *ngIf="promptJDMode === 'upload'">upload</ng-container> a brief description of the role</div>
          <div *ngIf="aiPromptFormGroup.get('jd').hasError('invalidFileType')" class="f-12 text-danger">Please upload supported file only</div>
        </div>
      </ng-container>
      <div class="">
        <div class="mb-1">What tone of voice would you like to use?<span class="text-danger">*</span></div>
        <div class="d-flex align-items-center justify-content-start flex-wrap" style="gap: 10px;">
          <div>
            <label class="position-relative d-flex align-items-center p-2 rounded-lg pointer mb-0" style="gap: 10px;" for="toneProfessional">
              <input data-testid="auto-app-email-campaign-assistant-input-5" formControlName="tone" hidden type="radio" name="tone" id="toneProfessional" value="professional" required>
              <div class="f-14">Professional</div>
              <div class="border position-absolute h-100 w-100 rounded-lg" style="left: 0;"></div>
            </label>
          </div>
          <div>
            <label class="position-relative d-flex align-items-center p-2 rounded-lg pointer mb-0" style="gap: 10px;" for="toneCasual">
              <input data-testid="auto-app-email-campaign-assistant-input-6" formControlName="tone" hidden type="radio" name="tone" id="toneCasual" value="casual" required>
              <div class="f-14">Casual</div>
              <div class="border position-absolute h-100 w-100 rounded-lg" style="left: 0;"></div>
            </label>
          </div>
          <div>
            <label class="position-relative d-flex align-items-center p-2 rounded-lg pointer mb-0" style="gap: 10px;" for="toneEnthusiastic">
              <input data-testid="auto-app-email-campaign-assistant-input-7" formControlName="tone" hidden type="radio" name="tone" id="toneEnthusiastic" value="enthusiastic" required>
              <div class="f-14">Enthusiastic</div>
              <div class="border position-absolute h-100 w-100 rounded-lg" style="left: 0;"></div>
            </label>
          </div>
          <div>
            <label class="position-relative d-flex align-items-center p-2 rounded-lg pointer mb-0" style="gap: 10px;" for="tonePersuasive">
              <input data-testid="auto-app-email-campaign-assistant-input-8" formControlName="tone" hidden type="radio" name="tone" id="tonePersuasive" value="persuasive" required>
              <div class="f-14">Persuasive</div>
              <div class="border position-absolute h-100 w-100 rounded-lg" style="left: 0;"></div>
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0">
    <button data-testid="auto-app-email-campaign-assistant-button-1" [disabled]="isGenerating" class="wc-btn gradientbtn" (click)="trySubmitModal()"><i class="fa fa-spin fa-spinner-third mr-1" *ngIf="isGenerating"></i> Generate</button>
  </div>
</div>
